<template>
    <div class="continer">
        <background>
            <div class="info">
                <div class="info-step">
                    <el-steps :active="activeStep" align-center finish-status="success">
                        <el-step>
                            <template slot="title">
                                <div class="custom-title">
                                    <div class="text">原始凭证</div>
                                    <div>智能提取</div>
                                    <div v-if="activeStep === 0" class="three-dots"></div>
                                </div>
                            </template>
                        </el-step>    
                        <el-step>
                            <template slot="title">
                                <div class="custom-title">
                                    <div class="text">经济行为</div>
                                    <div>智能分析</div>
                                    <div v-if="activeStep === 1" class="three-dots"></div>
                                </div>    
                            </template>
                        </el-step>
                        <el-step>
                            <template slot="title">
                                <div class="custom-title">
                                    <div class="text">AI智能</div>
                                    <div>财务核算</div>
                                </div>
                            </template>
                        </el-step>
                    </el-steps>
                </div>
                <div v-if="activeStep === 3" class="info-footer">
                    <div class="tips">已进入AI智能核算</div>
                    <div class="tips-desc">您可继续扫描下一单凭证，无需等待</div>
                    <div class="next-btn"  @click="makeOrder">继续制单</div>
                </div>
            </div>
        </background>
        <pageHeader isCustom>
            <div class="logout-btn" v-if="activeStep === 3" @click="logout">退出登录</div>
        </pageHeader>
        <tipsDialog :dialogVisible="tipsDialogVisible" :tipsMessage="errorInfo.info">
            <div class="text-btn" @click="handleTipsBtn">{{errorInfo.isConfirmBtn ? '确定' : '我知道了'}}</div>
        </tipsDialog>
        <tipsDialog tipsMessage="制单失败，请取走托盘中全部纸张，若有需要，请重新制证"
                     :dialogVisible="voucherErrorDialogVisible">
                     <div class="text-btn" @click="openDish">确定</div>
        </tipsDialog>
        <exitTicketProcess ref="exitTicketProcess" exitTitle="取出全部原始凭证后，请点击收回托盘" @dishHandleFinish="dishHandleFinish" @dishHaveNoPaper="dishHandleFinish"></exitTicketProcess>
        <errorDialog :errorMessage="errorMessage" :dialogVisible="errorDialogVisible"></errorDialog>
        <tipsDialog  :tipsMessage="`入库成功，纸仓已满，无法继续制单，将在${countDownNum}秒后退出登录`"
                     :dialogVisible="dialogVisible">
        </tipsDialog>
        <receiveTicket v-if="finishStore"></receiveTicket>
    </div>
</template>
<script>
import background from '@/components/background'
import pageHeader from '@/components/pageHeader'
import tipsDialog from '@/components/tipsDialog'
import errorDialog from '@/components/errorDialog'
import exitTicketProcess from '@/components/exitTicketProcess'
import receiveTicket from '@/components/receiveTicket'
import paperDishMixin from '@/mixin/paperDishMixin'
import scanMixin from '@/mixin/scanMixin'
import { getBillVerifyInfo } from '@/api/order'
import {uploadLogs, accomplish, createTask} from '@/api/user'
import { getCookie } from "@/utils/auth";
export default {
    components: { background,pageHeader,tipsDialog,errorDialog,exitTicketProcess,receiveTicket },
    mixins: [paperDishMixin,scanMixin],
    data(){
        return {
            activeStep: 0,
            voucherErrorDialogVisible: false,
            errorInfo: {
                info: '',
                isConfirmBtn: false
            },
            tipsDialogVisible: false,
            dialogVisible: false,
            // 未知错误
            errorMessage: '',
            errorDialogVisible: false,

            // 是否入库成功
            finishStore: false
        }
    },
    mounted(){
        this.getInfo()
    },
    computed: {
        imageNum(){
            let imageInfo = JSON.parse(localStorage.getItem('imgShowList'))
            return imageInfo.length || 0
        },
        orgId() {
            if(getCookie('orgInfo')){
                return +(JSON.parse(getCookie('orgInfo')).id)
            }else {
                return 0
            }   
        }
    },
    methods:{
        // 获取记账信息
        getInfo(){
            if(!this.orgId) return this.$message.error('数据异常')
            getBillVerifyInfo({orgId:this.orgId}).then(res => {
                if(res.code === 200){
                    // 接口未返回，轮询请求
                    if(res.data.status === 2){
                        let timer = setTimeout(() => {
                            this.getInfo()
                            clearTimeout(timer)
                        },2000)
                    }else if(res.data.status === 0){
                        // 错误信息
                        this.errorInfo.info = res.data.errorMessage
                        this.errorInfo.isConfirmBtn = true
                        this.errorInfo.isBack = true
                        this.tipsDialogVisible = true
                    }else if(res.data.status === 1) {
                        accomplish({orgId:this.orgId}).then(res => {
                            if(res.code === 200){
                                // 走下一步
                                this.activeStep = 1
                                let secondStepTime = this.getRandomInt(5,8)
                                setTimeout(() => {
                                    this.activeStep = 3
                                    this.retain().then(res => {
                                        this.finishStore = true
                                    }).catch(e => {
                                        if(e.status === -11){
                                            this.dialogVisible = true
                                            this.handleCountDown()
                                        }
                                    })
                                },secondStepTime * 1000)
                            }else {
                                this.voucherErrorDialogVisible = true
                            }
                        }).catch(() => {
                            this.voucherErrorDialogVisible = true
                        })
                    }
                }

            }).catch(() => {
                this.voucherErrorDialogVisible = true
            })
        },
        // 弹出托盘
        openDish(){
            this.$refs.exitTicketProcess.getDishHavePaper()
        },
        dishHandleFinish(){
            this.$router.push({name: 'start'})
        },
        logout(){
            uploadLogs({
                content: '按钮触发，主动退出',
                errorCode: 0,
                module: '退出登录'
            }).catch(e => {})
            this.$store.dispatch('LogOut').then(() => {
                this.$router.push({name: 'login'})
            })
        },
         // 纸仓满退出登录流程
        handleCountDown(){
            let remainingSeconds = 15;
            this.countDownNum = remainingSeconds
            let that =  this
            this.timerId = setInterval(function() {
                if (remainingSeconds === 0) {
                    clearInterval(that.timerId);
                    that.dialogVisible = false
                    that.$store.dispatch('LogOut').then(() => {
                        that.$router.push({name: 'login',query:{status: 11}})
                    })
                } else {
                    that.countDownNum = remainingSeconds
                    remainingSeconds--;
                }
            }, 1000);
        },
        handleTipsBtn(){
            if(this.errorInfo.isBack){
                this.$router.go(-1)
            }else {
                this.tipsDialogVisible = false
            }
        },
        // 获取随机时间
        getRandomInt(min, max) {
            min = Math.ceil(min); // 将min向上取整
            max = Math.floor(max); // 将max向下取整
            return Math.floor(Math.random() * (max - min + 1)) + min; // 返回min到max之间的随机整数
        },
        // 获取第一步随机时间
        getStepOneSecond(num){
            let secondsNum = 0
            if(0 < num && num <= 5){
                secondsNum = this.getRandomInt(1,5)
            }else if (5 < num && num <= 10){
                secondsNum = this.getRandomInt(6,8)
            }else if (10 < num && num <= 15){
                secondsNum = this.getRandomInt(8,10)
            }else if(15 < num && num <= 30){
                secondsNum = this.getRandomInt(10,15)
            }else {
                secondsNum = this.getRandomInt(15,20)
            }
            return secondsNum
        },
        makeOrder(){
            createTask().then(res => {
                if(res.code === 200){
                    localStorage.removeItem('imgShowList')
                    localStorage.removeItem('blankImageList')
                    this.$router.push({name: 'waitScan'})
                }
            })
        },
    }
}
</script>
<style lang="less" scoped>
    .continer {
        height: 100%;
        width: 100%;
        overflow: hidden;
    }
    .info {
        &-step {
            height: 180px;
            width: 1550px;
            margin: 200px auto 100px auto;
        }
        &-footer {
            .tips {
                text-align: center;
                font-size: 46px;
                font-weight: 500;
                margin-bottom: 30px;
                &-desc{
                    font-size: 30px;
                    text-align: center;
                    font-weight: 500;
                }
            }
            .next-btn {
                display: block;
                width: 322px;
                margin: 86px auto 50px auto;
                padding: 20px 0;
                box-sizing: border-box;
                background: radial-gradient( 0% 141% at -1% 0%, #C62D2F 0%, #B23B34 100%);
                border-radius: 8px;
                font-weight: 400;
                font-size: 28px;
                text-align: center;
                color: #FFFFFF;
            }
        }
    }
    .logout-btn {
        position: absolute;
        padding: 17px 22px;
        top: 42px;
        right: 40px;
        background: rgba(239,239,239,0.5);
        border-radius: 8px;
        font-size: 32px;
        text-align: center;
        color: #FFFFFF;
    }
    .custom-title{
        font-size: 36px;
        .text {
            margin-bottom: 5px;
        }
    }
    /deep/ .el-step__icon {
        height: 38px;
        width: 38px;
        font-size: 24px;
        margin-top: -6px;
    }
    /deep/ .el-step__title {
        margin-top: 35px;
    }
    /deep/.el-step .el-step__line {
        width: 455px;
        margin-left: 30px;
    }
    /deep/ .el-step__title.is-process {
        color: #F7636E;
        font-weight:normal !important;
    }
    /deep/ .el-step__head.is-process {
        color: #F7636E;
        border-color: #F7636E;
    }
    /deep/ .el-step__head.is-success > .el-step__line {
        background-color: #F7636E !important;
    }
    /deep/ .el-step__title.is-success {
        color: #F7636E;
        font-weight: 500;
        margin-top: 30px;
    }
    /deep/ .el-step__head.is-success {
        color: #F7636E;
        border-color: #F7636E;
        .el-step__icon.is-text{
          border: none; //不显示圆圈
        //   position: absolute;
        //   top:-5px;
          width: 44px;
          height: 44px;
          background-color: #fff;
          background-size: 100% 100%;
          background-image: url('~@/assets/images/busImage/check-circle.png'); 
        }
        .el-step__icon-inner {
          display: none; //不显示内部数字
        }
    }
    .three-dots {
      --size: 20px;
      display: inline-block;
      font-size: var(--size);
      height: var(--size);
      line-height: var(--size);
      overflow: hidden;
      vertical-align: bottom;
    }

    .three-dots::after {
      display: inline-block;
      white-space: pre;
      content: '\A.\A. .\A. . .';
      animation: loop 2s steps(4) infinite;
    }

    @keyframes loop {
      to {
        transform: translateY(calc(0px - var(--size) * 4));
      }
    }
</style>


